import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79c6b339"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "video-item" }

import { watchEffect, ref, computed } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'VideoItem',
  props: {
    width: null,
    list: null
  },
  setup(__props: any) {

const props = __props as {
  width: any;
  list: any;
};



const backgroundStyle = ref({ image: '', position: '' });
watchEffect(() => {
  // debugger;
  // 当传入的 frames 为空的时候，就是本 VideoItem 不需要渲染的时候
  if (props.list) {
    const imageList = [];
    const positionList = [];
    for (let i = 0; i < props.list.length; i++) {
      const frame: any = props.list[i];
      const blobUrl = frame.url;
      const position = frame.position;

      const image = blobUrl ? `url(${blobUrl})` : `linear-gradient(#181818, #181818)`;
      imageList.push(image);
      positionList.push(position);
    }

    backgroundStyle.value = {
      image: imageList.join(','),
      position: positionList.join(','),
    };
  }
});
const frameHeight = 70;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "video-frame",
      style: _normalizeStyle({
        backgroundImage: backgroundStyle.value.image,
        backgroundPosition: backgroundStyle.value.position,
        height: frameHeight + 'px',
        width: Number(props.width) + 'px',
        backgroundRepeat: 'no-repeat',
      })
    }, null, 4)
  ]))
}
}

})